import { Button, Modal } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import API from "../../../api/axios";
import { toast } from "react-toastify";
import { APP_URLS } from "../../../api/url";
import { ThreeDots } from "react-loader-spinner";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import { APIError } from "../../../core/utils";
import { ModalWrapper } from "../style/style";
import moment from "moment";
import Cancel from "../../../assets/Images/icons/Cancel.svg";
import faHide from "../../../assets/Images/icons/svgIcon/FaHide.svg"
import ViewIcon from "../../../assets/Images/icons/svgIcon/eye2.svg"
import Pagination from "../../../assets/SharedComponents/Pagination";
import JSONModal from "../../../assets/SharedComponents/JSONModal/JSONModal";
import { confirmAlert } from "react-confirm-alert";

const countries = JSON.parse(localStorage.getItem("countries")) || []

const FPJSDataPreview = ({ id, flagLabel }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loaded, _loaded] = useState(false);
  const [actionloader, _actionloader] = useState(false);

  const [history, _history] = useState([]);

  const [totalPage, _totalPage] = useState(0);
  const [total, _total] = useState(0);
  const [page, setPage] = useState(1);

  const [textRow, _textRow] = useState({
    id: null,
    type: null,
    text: null,
  })

  useEffect(() => {
    if (!open) {
      setPage(1);
      return;
    }
    getHistory();
  }, [open, page]);

  const getHistory = async () => {
    _loaded(true);
    try {
      const res = await API.get(
        `${APP_URLS.LIST_FLAGGED_USERS}/${id}/flags?page=${page}`
      );
      const { data: resp } = res;
      if (resp.success) {
        _history(resp?.data?.data ?? []);
        _totalPage(resp?.data?.last_page ?? 1);
        _total(resp?.data?.total ?? 0);
      } else {
        toast.error(resp.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      let error_message = APIError(error);
      toast.error(error_message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      _loaded(false);
    }
  };

  const handleDrop = (id, type, text) => {
    if (id === textRow.id && type === textRow.type) {
      _textRow({
        id: null,
        type: null,
        text: null,
      })
      return
    }
    _textRow({
      id: id,
      type: type,
      text: text
    })
  }

  const handleClick = (report) => {
    if (report?.metadata?.ad_vehicle_id) {
      window.open(
        `${process.env.REACT_APP_FRONTOFFICE_URL_HTTPS}/fr/public-ads/${report.metadata.ad_vehicle_id}`,
        "_blank"
      )
      return
    }
    if (report?.metadata?.chat_id) {
      window.open(
        `/chats-messages/${report.metadata.chat_id}`,
        "_blank"
      )
    }
  }

  const handleDelete = (fpID) => {
    if (actionloader) return;
    confirmAlert({
      title: `Confirm to delete`,
      message: `Are you sure you want to perform this action?`,
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name", // Custom class name for the overlay
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            _actionloader(true);
            API.delete(`${APP_URLS.LIST_FLAGGED_USERS}/delete_flag/${fpID}`)
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  toast.success(`Action has been taken successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  getHistory();
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch(function (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              })
              .finally(() => {
                _actionloader(false);
              });
          },
        },
        { label: "No" },
      ],
    });
  }

  return (
    <>
      <Button onClick={handleOpen} className="viewButton">
        View
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex: 10
        }}
      >
        <ModalWrapper>
          <h3>FPJS Data</h3>
          <img src={Cancel} alt="" className="closeButton" onClick={handleClose} />
          <div>
            <span>
              Total Records : <b>{total}</b>
            </span>
          </div>
          <div className="tableContainer">
            <table className="modalTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th>Visitor ID</th>
                  <th>
                    FPJS IP <br />
                    User IP
                  </th>
                  <th>Email <br />Phone </th>
                  <th>Flag Reason</th>
                  <th>Flag Points</th>
                  <th>Created At</th>
                  <th>Address</th>
                  <th>
                    Browser details
                    <br />
                    Fp Request Data
                    <br />
                    View Model
                  </th>
                  <th>Keywords</th>
                  <th>User Input</th>
                  <th>URL</th>
                  <th>Action</th>
                </tr>
              </thead>
              {loaded ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {history && history.length > 0 ? (
                    history.map((report, index) => {
                      const country = countries.find(
                        (o) => o.id === report.country_id
                      );
                      const isClickable = report?.metadata?.ad_vehicle_id ?? report?.metadata?.chat_id
                      return (
                        <Fragment key={`history-${report.id}-${index}`}>
                          <tr className={`${report.deleted_at ? "deletedRow" : ""} table-row`}>
                            <td>{report?.visitor_id ?? "-"}</td>
                            <td>
                              {report?.ip_address ?? "-"} <br />
                              {report?.user_ip_address ?? "-"}
                            </td>
                            <td>
                              {report?.email ?? "-"}
                              <br />
                              {report?.phone ? `${report?.phone_code} ${report.phone}` : "-"}
                            </td>
                            <td>{report?.fraud_flags_id ? flagLabel[report.fraud_flags_id] : "-"}</td>
                            <td>{report?.risk_points ? `+${report.risk_points}` : 0}</td>
                            <td> {moment(report.created_at).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm")}</td>
                            <td>
                              {[
                                report?.city,
                                report?.subdivisions,
                                report?.postal_code,
                                country?.custom_name
                              ]
                                .filter(Boolean)
                                .join(', ')}
                            </td>
                            <td>
                              <JSONModal buttonText="Show browser details" modalHeader="Browser Details" jsonData={report?.browser_details} />
                              <br />
                              <JSONModal buttonText="Show FP request data" modalHeader="Fingerprint Request Data" jsonData={report?.fp_request_data} />
                              <br />
                              {isClickable ?
                                <img
                                  src={ViewIcon}
                                  className="viewIcon"
                                  onClick={() => handleClick(report)}
                                  title={report?.metadata?.ad_vehicle_id ? 'View Ad Vehicle' : 'View Chat Messages'}
                                  alt="view"
                                />
                                : "-"
                              }
                            </td>
                            <td>
                              {report?.flagged_keywords && report?.flagged_keywords.length > 0 ?
                                report.flagged_keywords.join(", ") :
                                "-"
                              }
                            </td>
                            <td>
                              {report?.metadata?.value ?
                                <>
                                  <span>{(report.metadata.value).slice(0, 15)}...</span>
                                  <img src={faHide} alt="show" className={`${textRow.id === report.id && textRow.type == "userInput" ? "close" : "open"} dropdownButton`} onClick={() => handleDrop(report.id, "userInput", report.metadata.value)} />
                                </>
                                : "-"
                              }
                            </td>
                            <td>
                              {report?.url ?
                                <>
                                  <span>{(report.url).slice(0, 15)}...</span>
                                  <img src={faHide} alt="show" className={`${textRow.id === report.id && textRow.type == "url" ? "close" : "open"} dropdownButton`} onClick={() => handleDrop(report.id, "url", report.url)} />
                                </>
                                : "-"
                              }
                            </td>
                            <td>
                              {report.deleted_at ?
                                <span className="rejected disabled">Deleted</span>
                                :
                                <button className="reject" onClick={() => handleDelete(report.id)}>
                                  Delete
                                </button>
                              }
                            </td>
                          </tr>
                          {
                            textRow.text && textRow.id === report.id && <tr className="table-row">
                              <td className="text-details">{textRow.text}</td>
                            </tr>
                          }
                        </Fragment>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
              )}
            </table>
          </div>
          {totalPage > 1 ? (
            <Pagination
              totalPages={totalPage}
              page={page}
              key={totalPage}
              onPageClick={(page) => setPage(page + 1)}
            />
          ) : (
            ""
          )}
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default FPJSDataPreview;
